import { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { FitTypeServices } from '../../../services';
import { IBaseItem } from '../types';

const SelectFitType = (props: any) => {
    const [fittypes, setFitTypes] = useState<IBaseItem[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [selected, setSelected] = useState<number>(0);


    useEffect(() => {

        (async() => {
            const getResponse = await FitTypeServices.GetFitTypes();

            setFitTypes(getResponse);
            setIsLoading(false);
        })();

    }, []);

    const onControlChange = (e: any) => {
        setSelected(parseInt(e.target.value));

        if (props.SuscribedChange) props.SuscribedChange(parseInt(e.target.value));
    }

    return (
        <>
            <Form.Group className={`justify-content-center ${props.ClassGroup || ''}`}>
                <Form.Label className={`font-label-form ${(!(props.Label)) ? 'd-none' : ''}`}>{props.Label || ''}</Form.Label>
                {
                    isLoading ?
                        <></>
                        :
                        <Form.Select 
                        size="sm"
                        disabled={props.Disabled || false}
                        onChange={(e: any) => onControlChange(e)}
                        key={'select-fit-type'}
                        defaultValue={(props.DefaultValue && fittypes.length > 0 ? props.DefaultValue : undefined)}>
                            {
                                fittypes?.map((element: IBaseItem, index: number) => {
                                    return (
                                        <option value={element.Id} key={`select-fit-type-${element.Id}`}>{element.Name}</option>
                                    )
                                    
                                })
                            }
                    </Form.Select>
                }

            </Form.Group>
        </>
    )
}

export default SelectFitType;
